import createIcon from '../../createIcon';

/**
 * @component @name Sorting
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC45ODgyOCAxOEgxMy41MDg4VjE2SDguOTg4MjhWMThaTTguOTg4MjggNlY4SDIyLjUwODhWNkg4Ljk4ODI4Wk04Ljk4ODI4IDEzSDE4LjAwODhWMTFIOC45ODgyOFYxM1oiIGZpbGw9IiMxNjE2MTYiLz4KPHBhdGggZD0iTTEuNDg4MjggNi41MzQ3NEwyLjY2Nzg0IDcuNjYyODVMMy42NzkxMyA2LjgxNDNWMTAuNUg1LjM1MjI1VjYuODE0M0w2LjMwODczIDcuNjYyODVMNy40ODgyOCA2LjUzNDc0TDQuNTE1NjkgMy43NUwxLjQ4ODI4IDYuNTM0NzRaIiBmaWxsPSIjMTYxNjE2Ii8+CjxwYXRoIGQ9Ik03LjQ4ODI4IDE3LjQ2NTNMNi4zMDg3MyAxNi4zMzcyTDUuMjk3NDQgMTcuMTg1N1YxMy40OTk4SDMuNjI0MzFMMy42MjQzMSAxNy4xODU3TDIuNjY3ODQgMTYuMzM3MUwxLjQ4ODI4IDE3LjQ2NTNMNC40NjA4NyAyMC4yNUw3LjQ4ODI4IDE3LjQ2NTNaIiBmaWxsPSIjMTYxNjE2Ii8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Sorting = createIcon('Sorting', [
  [
    'path',
    {
      d: 'M8.98828 18H13.5088V16H8.98828V18ZM8.98828 6V8H22.5088V6H8.98828ZM8.98828 13H18.0088V11H8.98828V13Z',
      key: '15hc6i',
    },
  ],
  [
    'path',
    {
      d: 'M1.48828 6.53474L2.66784 7.66285L3.67913 6.8143V10.5H5.35225V6.8143L6.30873 7.66285L7.48828 6.53474L4.51569 3.75L1.48828 6.53474Z',
      key: '4ia2qg',
    },
  ],
  [
    'path',
    {
      d: 'M7.48828 17.4653L6.30873 16.3372L5.29744 17.1857V13.4998H3.62431L3.62431 17.1857L2.66784 16.3371L1.48828 17.4653L4.46087 20.25L7.48828 17.4653Z',
      key: '1pdjgs',
    },
  ],
]);

export default Sorting;
